// extracted by mini-css-extract-plugin
export default {"stickyArticleHeader":"J_bT","stickyArticleHeaderContainer":"J_bV","stickyArticleHeaderButton":"J_bW","text_left":"J_bX","progressContainer":"J_bY","progressBar":"J_bZ"};